import api from "../api";
import {
  FETCH_CITIES_BEGIN,
  FETCH_CITIES_SUCCESS,
  FETCH_CITIES_FAILURE
} from "../types";

export const fetchCitiesBegin = () => ({
  type: FETCH_CITIES_BEGIN
});

export const fetchCitiesSuccess = data => ({
  type: FETCH_CITIES_SUCCESS,
  data
});

export const fetchCitiesFailure = error => ({
  type: FETCH_CITIES_FAILURE,
  error
});

// export const getCitiesList = () => dispatch => {
//   dispatch(fetchCitiesBegin());

//   return api.cities
//     .search()
//     .then(resp => {
//       dispatch(fetchCitiesSuccess(resp.data.cities));
//       return resp.data.cities;
//     })
//     .catch(error => dispatch(fetchCitiesFailure(error)));
// };

export const getCitiesList = input => dispatch => {
  dispatch(fetchCitiesBegin());

  return api.cities
    .search(input)
    .then(resp => {
      dispatch(fetchCitiesSuccess(resp.data.cities));
      return resp.data.cities;
    })
    .catch(error => dispatch(fetchCitiesFailure(error)));
};
